import { Toolbar } from "@circle-react/components/QuickPostV3/Composer/Toolbar";
import { Topics } from "@circle-react/components/QuickPostV3/Composer/Topics";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Divider } from "@circleco/compass/components/Divider";

interface FooterToolbarRowProps {
  inline?: boolean;
}

export const FooterToolbarRow = ({ inline }: FooterToolbarRowProps = {}) => (
  <div className="shrink-0 px-6">
    <div
      className={classNames(
        "border-primary min-w-0 border-t",
        inline
          ? "flex min-h-16 items-center gap-4 py-1.5"
          : "flex h-16 items-center",
      )}
    >
      <Toolbar shrink={inline} />
      {inline ? (
        <>
          <Divider
            orientation="vertical"
            className="border-primary h-6 shrink-0"
          />
          <div className="min-w-0 flex-1">
            <Topics inline />
          </div>
        </>
      ) : null}
    </div>
    {!inline ? <Topics className="border-primary border-t" /> : null}
  </div>
);
